import styled from "styled-components";

import { colorBadgeStyle } from "./ColorBadgeStyle";

const HtmlActionColorBadgeStyle = styled.span`
    // Vanilla styles injection
    ${colorBadgeStyle};
`;

export const HtmlColorBadgeStyle = styled(HtmlActionColorBadgeStyle).attrs(() => ({ className: "aevi-status-badge" as string }))``;
